import { useCommunityContext } from 'providers';
import { useMemo } from 'react';

import { RewardTransactionAction } from '@jebel/constants';

import { useGetPointsPerActionsQuery } from 'shared/graphql';

type PointsPerActions = Record<RewardTransactionAction, number>;

const DEFAULT: PointsPerActions = {
  [RewardTransactionAction.AdViewed]: 0,
  [RewardTransactionAction.PostCreated]: 0,
  [RewardTransactionAction.PostLiked]: 0,
  [RewardTransactionAction.CommentCreated]: 0,
  [RewardTransactionAction.DiscountRedeemed]: 0,
  [RewardTransactionAction.BusinessClaimed]: 0,
};

export function useCommunityPointsPerActions() {
  const { selectedCommunity: community } = useCommunityContext();

  const { data: response, loading } = useGetPointsPerActionsQuery({
    skip: !community,
    variables: {
      community: { id: community?.id as string },
    },
  });

  const data: PointsPerActions = useMemo(() => {
    const data = response?.pointsPerActions ?? [];
    const entries = data.map(p => [p.action, p.points]);
    const payload = Object.fromEntries(entries) as PointsPerActions;

    return Object.assign({}, DEFAULT, payload);
  }, [response]);

  return {
    data,
    loading,
  };
}
